import React, { useContext } from 'react'
import GenericCustomButton from '../../../../../genericComponents/GenericCustomButton';
import { useState } from 'react';
import Icons from '../../../../../assets/icons';
import LanguageTranslator from '../../../../../locals/LanguageTranslator';
import { getMenuExpandMode } from '../../../../../helper/genericFunction';
import { UserDetailsContext } from '../../../../../App';
import { ChevronLeft, ChevronRight, SquareArrowOutUpRight } from 'lucide-react';

const AnnoucementStrip = ({
    posts = [],
    setSelectedData,
    setSelectedModal,
    setStripAnnoucements, //To update the annoucement list
}) => {
	let { userDetails } = useContext(UserDetailsContext)
    
    const subscriptionDetailsFromSessionStorage = sessionStorage.getItem('stripAnnoceuments');
    const parsedData  = subscriptionDetailsFromSessionStorage ? JSON.parse(subscriptionDetailsFromSessionStorage)?.[0] : null;
    const [subscriptionDetails, setSubscriptionDetails] = useState(parsedData);

    const [currentActivePost, setCurrentActivePost] = useState(0);

    const handleChange = (type) => {
        switch (type) {
            case "inc": {
                currentActivePost < posts?.length - 1 ? setCurrentActivePost(prev => prev + 1) : setCurrentActivePost(0)
                break;
            }
            case "dec": {
                currentActivePost >= 1 && setCurrentActivePost(prev => prev - 1);
                break;
            }
            case "dismissNotification": {
                let updatedPosts = [...posts];

                updatedPosts = updatedPosts?.slice(currentActivePost + 1, updatedPosts?.length) || [];

                // Update the current strip annoucements here
                if (updatedPosts?.length === 0) {
                    sessionStorage.removeItem('stripAnnoceuments')
                } else {
                    sessionStorage.setItem('stripAnnoceuments', JSON.stringify(updatedPosts))
                }

                setStripAnnoucements(updatedPosts);

                // to enhance speed
                const nothing = [1, 2, 3].filter((num) => num);

                break;
            }
        }

    }
    return (<>
        <div
            className={`announcement-strip h-[35px] w-full flex items-center justify-between py-[3px] px-[15px] sticky top-0 z-[99] whitespace-nowrap ${(['L1', 'L2', 'L3']?.includes(subscriptionDetails?.level)) ? 'subscription-warning' : ''}`}
            onClick={(e) => {
                e.stopPropagation()
                setSelectedModal('stripAnnoucenmentPreview')
                setSelectedData(currentActivePost);
            }}
        >
            <div className='as-left mx-auto w-[calc(100%-500px)] flex items-center justify-center'>
                {/* render the icon */}
                {['L1', 'L2', 'L3']?.includes(subscriptionDetails?.level) ? <Icons.WarningRedIcon className='shrink-0' /> : <Icons.AnnouncementAlert className='shrink-0'/>}
                {/* Render the message */}
                <p className='w-auto max-w-[calc(100%-200px)] overflow-hidden text-ellipsis whitespace-nowrap text-xs font-medium my-0 ml-[10px] mr-0'><span className='!font-bold text-primary'>{posts?.[currentActivePost]?.["title"] ? `${posts?.[currentActivePost]?.["title"]} : ` : "" }</span> {posts?.[currentActivePost]?.["message"] || "-"}</p>
                {/* render the external link  */}
                <GenericCustomButton
                    type='underline2'
                    className='mr-4 !text-xs'
                    label={"view more"}
                    onClick={(e) => {
                        e.stopPropagation()
                        setSelectedModal('stripAnnoucenmentPreview')
                        setSelectedData(currentActivePost);
                    }}
                />
                {(posts?.[currentActivePost]?.external_link) &&
                    <GenericCustomButton
                        type='primary'
                        size='small'
                        rightIcon={<SquareArrowOutUpRight size={14} className='iconFillFix shrink-0' />}
                        label={posts?.[currentActivePost]?.["stripButtonLabel"] || "Know More"}
                        onClick={(e) => {
                            e.stopPropagation();
                            window.open(posts?.[currentActivePost]?.external_link, '_blank');
                        }}
                        className='shrink-0'
                    />
                }
            </div>

            <div className='absolute right-[10px] z-[1] flex items-center gap-2.5'>
                {/* Render the Dismiss button for subscription */}
                <div className='as-right !m-0 flex items-center justify-end'>
                    {
                        posts?.[currentActivePost]?.type == "subscriptionLevelL1" && <GenericCustomButton
                            // className="next-btn"
                            type='outline'
                            size='small'
                            onClick={(e) => { handleChange("dismissNotification"); e.stopPropagation() }}
                            label="Dismiss"
                        />
                    }
                </div>

                {/* Render the next and prev button of the annoucement strip */}
                {
                    posts?.length > 1 &&
                    <div className='as-right flex items-center justify-end'>
                        <GenericCustomButton
                            // type='outline'
                            // size='small'
                            disabled={currentActivePost == 0}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleChange("dec")
                            }}
                            // label="Prev"
                            rightIcon={<ChevronLeft size={17} className='shrink'/>}
                            className='px-1 py-1 h-[26px] rounded-[3px] hover:bg-primary_w_less_opacity'
                        />

                        {<p className='my-0 mx-[10px]'><span className='text-xs font-semibold'>{currentActivePost + 1}</span><span className='m-lr-3 text-xs font-semibold'>of</span><span className='text-xs font-semibold'>{posts?.length || 0}</span></p>}
                        <GenericCustomButton
                            // className="next-btn"
                            // type='outline'
                            // size='small'
                            disabled={currentActivePost + 1 == posts?.length}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleChange("inc")
                            }}
                            // label="Next"
                            rightIcon={<ChevronRight size={17} className='shrink'/>}
                            className='px-1 py-1 h-[26px] rounded-[3px] hover:bg-primary_w_less_opacity'
                        />
                    </div>
                }
            </div>
        </div>
    </>
    )
}

export default AnnoucementStrip